export default "__VITE_PUBLIC_ASSET__c0f3d267__"